export const FOOTER_GET = 'FOOTER_GET';
export const FOOTER_EDIT = 'FOOTER_EDIT';
export const OPTIONS_GET = 'OPTIONS_GET';
export const IMAGE_UPLOAD = 'IMAGE_UPLOAD';
